<template lang="pug">
  section.section-param(id="startWork" class="d-flex justify-center")
    div.background-sw
    v-container.mx-auto(fluid)
      v-card.title-style.title-style-sm
        p.frontText(v-if="$vuetify.breakpoint.xsOnly") Как начать работать </br> с нами
        p.frontText(v-else) Как начать работать с нами
        p.backText( v-if="$vuetify.breakpoint.mdAndUp") Как начать работать
      v-card.carousel-card-sw.elevation-0(v-if="$vuetify.breakpoint.xsOnly" fluid)
        v-carousel.carousel-sw(
          v-model="startSlide"
          continuous
          ref="carousel"
          :show-arrows="false"
          hide-delimiter-background
          hide-delimiters
          )
          v-carousel-item(v-for="(step, i) in steps" :key="'carousel'+i")
            v-sheet.color-sheet
              stepWork.item-sw(
                :stepWork="step"
                :startSlide="startSlide+1"
                :numberStepNow="numberNextStep"
                :isRestart="isRestart"
                isCarousel
                @onEndStepCarusel="newStartStepWork"
                )
        v-card.footer-sw.elevation-0(class="d-flex justify-center")
          a.mt-2.ml-2(v-for="i in 4" :key="i")
            font-awesome-icon.slide(
              :class="{'active': i === startSlide+1}"
              @click="setSlade(i)"
              :icon="['fa', 'window-minimize']"
              )
      v-card.carousel-card-sw.elevation-0(v-else-if="$vuetify.breakpoint.smOnly || $vuetify.breakpoint.mdOnly" id="carouselMdSW" fluid)
        v-carousel.carousel-sw-md(
          v-model="startSlideMd"
          continuous
          ref="carouselMd"
          :show-arrows="false"
          hide-delimiter-background
          hide-delimiters
          )
          v-carousel-item(v-for=" i in 2" :key="'carouselMd'+i")
            v-sheet.sheet-carusel-md
              stepWork.item-carusel-md.mr-auto(
                :stepWork="i===1 ? steps[0] : steps[2]"
                :isRestart="isRestart"
                :isDisabled="isDisabled(i===1 ? steps[0] : steps[2])"
                @onEndStep="newStartStepWork"
                :numberStepNow="numberNextStep"
                :isVisible="isVisible"
                isMdCarousel
                )
              stepWork.item-carusel-md(
                :stepWork="i===1 ? steps[1] : steps[3]"
                :isRestart="isRestart"
                :isDisabled="isDisabled(i===1 ? steps[1] : steps[3])"
                @onEndStep="newStartStepWork"
                :numberStepNow="numberNextStep"
                :isVisible="isVisible"
                isMdCarousel
                )
        v-card.footer-carusel-md.elevation-0(class="d-flex justify-center")
          a.mt-2.ml-2(v-for="i in 2" :key="i")
            font-awesome-icon.slide(
              :class="{'active': i === startSlideMd+1}"
              @click="setSlade(i, true)"
              :icon="['fa', 'window-minimize']"
              )
      v-card.step-work-group.justify-space-between.elevation-0(v-else id="groupSW")
        stepWork(
          v-for="(step, i) in steps"
          :key="'step'+i"
          :stepWork="step"
          :isDisabled="isDisabled(step)"
          :isRestart="isRestart"
          :numberStepNow="numberNextStep"
          :isVisible="isVisible"
          @onEndStep="newStartStepWork"
          )
</template>


<script>
import stepWork from './ui/StepWork'

export default {
  name: "StartWorkSection",
  components: {
    stepWork
  },
  data () {
    return {
      isRestart: false,
      STARTNUNSTEP: 1,
      ENDNUNSTEP: 4,
      SMSIZESTART: 600,
      MDSIZEEND: 1264,
      numberStep: 1,
      numberNextStep: 1,
      startSlide: 0,
      startSlideMd: 0,
      isNeedSendStartSlideMd: false,
      isVisible: false,
      steps: [
        {
          numberStep: 1,
          headerText: 'Составление первичной заявки',
          bodyText: 'Укажите требуемые навыки специалистов в форме обратной связи. С вами свяжется персональный менеджер',
          isDisabled: false,
          isMargin: true
        },
        {
          numberStep: 2,
          headerText: 'Заключение договора',
          bodyText: 'Персональный менеджер обеспечит сопровождение заключения рамочного договора — поможет согласовать условия \n' +
              'и требования. Затем отправит документы через ЭДО — это позволит провести все организационные мероприятия в кратчайшие сроки',
          isDisabled: true,
          isMargin: true
        },
        {
          numberStep: 3,
          headerText: 'Согласование кандидатов',
          bodyText: 'Менеджер предоставит резюме подходящих под ваш запрос исполнителей \n' +
              'и поможет организовать интервью \n' +
              'с выбранными кандидатами',
          isDisabled: true,
          isMargin: true
        },
        {
          numberStep: 4,
          headerText: 'Быстрый старт',
          bodyText: 'Менеджер сопроводит заключение дополнительных соглашений \n' +
              'на одобренных кандидатов \n' +
              'и максимально быстро включит их в вашу команду/проект',
          isDisabled: true,
          isMargin: false
        }
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener('scroll', this.visible, { passive: true })
  },
  watch: {
    startSlide: {
      immediate: true,
      deep: true,
      handler() {
        this.numberNextStep = this.startSlide + 1
      }
    },
    startSlideMd: {
      immediate: true,
      deep: true,
      handler() {
        if (this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.mdOnly){
          this.updateSlideMd()
        }
      }
    }
  },
  methods: {
    visible () {
      const scrollWidth = document.documentElement.scrollWidth
      const target = (this.SMSIZESTART < scrollWidth) && (scrollWidth < this.MDSIZEEND) ? document.querySelector('#carouselMdSW') : document.querySelector('#groupSW');
      if (target) {
        let targetPosition = {
            top: window.pageYOffset + target.getBoundingClientRect().top,
            left: window.pageXOffset + target.getBoundingClientRect().left,
            right: window.pageXOffset + target.getBoundingClientRect().right,
            bottom: window.pageYOffset + target.getBoundingClientRect().bottom
          },
          windowPosition = {
            top: window.pageYOffset,
            left: window.pageXOffset,
            right: window.pageXOffset + document.documentElement.clientWidth,
            bottom: window.pageYOffset + document.documentElement.clientHeight
          }

        if (targetPosition.bottom > windowPosition.top &&
            targetPosition.top < windowPosition.bottom &&
            targetPosition.right > windowPosition.left &&
            targetPosition.left < windowPosition.right
        ) {
          this.isVisible = true
        } else {
          this.isVisible = false;
        }
      }
    },
    onResize () {
      const scrollWidth = document.documentElement.scrollWidth
      if ((this.SMSIZESTART < scrollWidth) && (scrollWidth < this.MDSIZEEND) ) {
        if (this.isNeedSendStartSlideMd) {
          this.updateSlideMd()
        }
        this.isNeedSendStartSlideMd = false
      } else {
        this.isNeedSendStartSlideMd = true
      }
    },
    updateSlideMd () {
      this.newStartStepWork(this.startSlideMd===0 ? 1 : 3, true)
      this.newRestart()
    },
    newRestart () {
      this.isRestart = !this.isRestart
    },
    setSlade(i, isMdCarousel) {
      if (isMdCarousel) {
        this.startSlideMd = i-1
      } else {
        this.startSlide = i-1
      }
    },
    isDisabled (step) {
      return step.numberStep !== this.numberNextStep
    },
    newStartStepWork (numberStep, setStartSlide) {
      this.numberStep = numberStep
      if (setStartSlide) {
        this.numberNextStep = numberStep
      } else {
        this.numberNextStep = numberStep === this.ENDNUNSTEP ? this.STARTNUNSTEP : numberStep + 1
      }
      if ((numberStep === this.ENDNUNSTEP) && !setStartSlide) {
        this.newRestart()
      }
      const scrollWidth = document.documentElement.scrollWidth
      if (this.SMSIZESTART > scrollWidth) {
        this.$refs.carousel.next()
      } else if ((this.SMSIZESTART < scrollWidth) && (scrollWidth < this.MDSIZEEND) && [2, 4].includes(numberStep) && !setStartSlide) {
        this.$refs.carouselMd.next()
        this.newRestart()
      }
    }
  }
}
</script>

<style scoped lang="sass">
  @import "ui/scss/variables.scss"
  @import "ui/scss/colors.scss"

  .background-sw
    background-image: url("~@/assets/fonSlideWork.svg")
    background-repeat: no-repeat
    background-size: cover
    height: auto
    max-height: 33%
    overflow: hidden
    position: absolute
    top: 37%
    left: 0
    right: 0
    bottom: 0
    z-index: 1

  .step-work-group
    background: transparent
    display: flex
    flex-wrap: nowrap
    margin: 10% $marginRightContent 6% $marginLeftContent
    height: 100%
    max-width: $maxWidthContent

  .color-sheet
    background-color: transparent

  .sheet-carusel-md
    background: transparent
    display: flex
    flex-wrap: wrap
    max-width: $maxWidthContent

  .slide
    background: $lightGrey
    margin-right: 4%
    height: 2px
    width: 30px
    border-radius: 0 !important

  .active
    background: $blueBasic

  .carousel-sw
    height: 350px

    .carousel-sw-md
      height: auto !important
      ::v-deep
        .v-window__container
          .v-window-item
            .v-image
              height: auto !important

  .item-carusel-md
    position: relative
    max-width: 45%
    min-width: 230px
    margin-bottom: 20px
    box-sizing: border-box

  .footer-carusel-md
    height: 20px
    max-width: $maxWidthContent
    justify-self: center
    background-color: transparent
    margin-top: max(calc(-25% + 80px), -130px)
    margin-bottom: 100px

  .item-sw
    height: 350px

  .carousel-card-sw
    height: auto !important
    background-color: transparent
    margin-left: $marginMax
    margin-right: $marginMax
    margin-top: 8%
    .footer-sw
      height: 20px
      margin-top: -133px
      max-width: $maxWidthContent
      justify-self: center
      background-color: transparent
      margin-bottom: 90px

  @media(max-width: $xxl)
    .background-sw
      max-height: 32%
      margin: 0 auto
      top: 35%

  @media(max-width: $lgAndDown)
    .background-sw
      margin-top: 40px
      max-height: 29%
      top: 35%

  @media(min-width: $lgAndUp)
    .carousel-card-sw
      display: none

  @media(max-width: $middle)
    .background-sw
      margin-top: 0px
      max-height: 20%
      top: 31%

  @media(max-width: $lgAndUp)
    .background-sw
      margin-top: 0px
      max-height: 21%
      top: 30%

  @media(max-width: $smAndDown)
    .title-style-sm
      margin-bottom: 75px !important
      margin-top: 1px !important
      
    .background-sw
      max-height: 18%
      top: 33%
      
  @media(max-width: $xsOnly)
    .background-sw
      background-image: url("~@/assets/1xsFonSlideWork.png") !important
      top: 35%
      background-size: contain
      z-index: 0

  @media(max-width: $small)
    .background-sw
      top: 38%
  
  @media(min-width: $xxsOnly)
    .carousel-card-sw
      .footer-sw
        margin-top: -110px !important

</style>